import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Alert from '@material-ui/lab/Alert'
import AlertTitle from '@material-ui/lab/AlertTitle'

import Window from 'components/dialog/Window'
import routerActions from 'store/modules/router'
import projectSelectors from 'store/selectors/project'
import authActions from 'store/modules/auth'
import authSelectors from 'store/selectors/auth'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0),
    width: '100%',
  },  
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    zIndex: 100,
    position: 'fixed',
  },
  alert: {
    width: '100%',
  },
  tabPaper: {
    flexGrow: 1,
  },
  content: {
    //marginTop: '100px',
    paddingTop: '75px',
    position: 'relative',
  },
}))

const AdminLayout = ({
  children,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const tokenerror = useSelector(authSelectors.tokenerror)
  const stripeConnect = useSelector(projectSelectors.currentProjectStripeConnect)

  const onSetupPayment = useCallback(() => {
    dispatch(routerActions.navigateTo('admin.payment'))
  }, [])

  const onCloseTokenError = useCallback(() => {
    dispatch(authActions.logout())
  }, [])

  const tokenErrorWindow = tokenerror ? (
    <Window
      open
      size="sm"
      title="Login Error"
      onSubmit={ onCloseTokenError }
      submitTitle="Continue to login"
    >
      <Typography>
        { tokenerror }
      </Typography>
    </Window>
  ) : null

  if(stripeConnect) {
    return (
      <>
        { children }
        { tokenErrorWindow }
      </>
    )
  }

  return (
    <div className={ classes.root }>
      <div className={ classes.toolbar }>
        <Alert
          className={ classes.alert }
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={ onSetupPayment }>
              Setup Payment
            </Button>
          }
        >
          <AlertTitle>Payment Not Configured</AlertTitle>
          You have not connected your Stripe account and so we can't take any payments for you until you connect your Stripe account.
        </Alert>
      </div>
      <div className={ classes.content }>
        { children }
      </div>
      { tokenErrorWindow }
    </div>
  )
}

export default AdminLayout